'use client';

import { useState } from 'react';

export function useTableSelection<T>() {
  const [selectedRows, setSelectedRows] = useState<Set<string>>(new Set());

  const toggleRow = (id: string) => {
    const newSelection = new Set(selectedRows);
    if (newSelection.has(id)) {
      newSelection.delete(id);
    } else {
      newSelection.add(id);
    }
    setSelectedRows(newSelection);
  };

  const selectAll = (rows: T[], getId: (row: T) => string) => {
    const allIds = rows.map(getId);
    setSelectedRows(new Set(allIds));
  };

  const clearSelection = () => {
    setSelectedRows(new Set());
  };

  const isSelected = (id: string) => selectedRows.has(id);

  return {
    selectedRows,
    toggleRow,
    selectAll,
    clearSelection,
    isSelected,
  };
}
